<template>
  <div class="app-container">
    <van-cell-group class="user-info-cell-group">
      <van-cell
        title="手机号"
        :value="webUserInfo.mobilePhone"
        size="large"
        to="/user/bind-phone"
        :is-link="true"
      />
    </van-cell-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters(['webUserInfo'])
  },
  methods: {}
}
</script>

<style scoped lang="scss">
.app-container {
  min-height: 100vh;
  background-color: #ededed;
}
</style>
